// Variables (can be placed in a separate _variables.scss file and imported)
$color-secondary-900: var(--color-secondary-900);
$button-padding: 0.2rem;

.threshold {
  background: var(--color-gray-50);
  padding-bottom: 0.5rem;
  &-panel {
    position: relative;
  }

  &-options {
    display: grid;
    grid-template-columns: auto 1fr 1fr;
    align-items: center;
    cursor: grab;

    &:active {
        cursor: grabbing;
      }

    &:hover {
    background: var(--color-gray-100);
    }
  }

  &-buttons {
    display: grid;
    grid-template-columns: repeat(4, 2.5rem);
    align-items: center;

    .color-picker label {
      padding: $button-padding;
      grid-template-columns: 1fr;
      background: initial;
    }
  }

  &-inputs {
    display: flex;
    align-items: center;

    select {
      max-width: 3.5rem;
    }

    .material-icons {
      cursor: pointer;
    }
  }
}

.square-button {
  margin: $button-padding;
  padding: $button-padding;
  border-radius: var(--radius-md);
  display: inline-block;
  border: 1px solid var(--color-gray-900);
  background: var(--color-bg-primary);
  cursor: pointer;

  &__color {
    height: 24px;
    width: 24px;
    border-radius: 2px;
  }

  &:hover {
    border-color: $color-secondary-900;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &--highlighted {
    border-color: $color-secondary-900;
    background: #08647E;

    img {
      filter: brightness(0) invert(1); // Simulates turning the icon white
    }
  }
}

.color-picker__popup {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.drag-icon{
  color: var(--color-gray-500);
}
